import { mixed } from 'yup'

import { TournamentField } from '../../types'
import { TournamentTypeMap } from '../constants/TournamentType'
import { typeTransform } from './utils'

export const tournamentTypeSchema = mixed<TournamentField>().required().transform(typeTransform(TournamentTypeMap))
